/**
 * 创建防抖函数
 * @param {*} func 回到函数
 * @param {*} delay 延迟时间，单位毫秒
 * @param {*} firstImmediate 短时间内首次是否立即执行
 * @returns 防抖函数
 */
export function debounce(func, delay, firstImmediate = false) {
  if (firstImmediate) {
    return debounceNonFirst(func, delay)
  } else {
    return debounceAll(func, delay)
  }
}

function debounceAll(func, delay) {
  let timeoutId
  return function (...args) {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

function debounceNonFirst(func, delay) {
  let timeoutId = null // 存储定时器ID
  let lastArgs = null // 存储最新参数
  let context = null // 存储函数上下文

  // 延迟执行的函数
  const later = () => {
    if (lastArgs) {
      // 只有后续调用存在时才执行
      func.apply(context, lastArgs)
      lastArgs = null // 清空参数避免重复执行
    }
    timeoutId = null // 重置定时器ID，允许下一次立即执行
  }

  return function (...args) {
    context = this // 保存当前上下文
    const shouldCallImmediate = !timeoutId // 判断是否立即执行

    // 清除前一次延迟
    if (timeoutId) clearTimeout(timeoutId)

    if (shouldCallImmediate) {
      // 首次调用：立即执行
      func.apply(context, args)
    } else {
      // 后续调用：保存参数，等待延迟执行
      lastArgs = args
    }

    // 设置新的延迟任务
    timeoutId = setTimeout(later, delay)
  }
}

export async function withLoading(loadingRef, task) {
  if (loadingRef.value) return
  loadingRef.value = true
  try {
    return await task()
  } finally {
    loadingRef.value = false
  }
}

export default {
  debounce,
  withLoading
}
